// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2P8hb","image":"styles_image__1NY02","text":"styles_text__3RV3o"};